import {Instance, SnapshotIn, types} from 'mobx-state-tree';
import {ELogicalElement} from '@progress-fe/core';
import {EntityBaseInfo} from 'core/models';

const LogicalElementInfo = types.compose(
  EntityBaseInfo,
  types.model('LogicalElementInfo', {
    logicalType: types.maybeNull(types.enumeration(Object.values(ELogicalElement)))
  })
);

export type TLogicalElementInfoModel = Instance<typeof LogicalElementInfo>;
export type TLogicalElementInfoSnapshotIn = SnapshotIn<typeof LogicalElementInfo>;

export {LogicalElementInfo};
